export default __webpack_public_path__ + "static/media/icon-doctor.e5bf6d9b.svg";